<template>
    <Head title="Products" />
    <BreezeAuthenticatedLayout>
        <template #header>
            <div class="grid grid-flow-col gap-4">
                <div>
                    <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                        Products
                    </h2>
                </div>
            </div>
        </template>
        <BreadCrumbs :items="breadCrumbs"></BreadCrumbs>
        <div class="relative w-full py-12 my-6 overflow-hidden shadow">
            <form @submit.prevent="form.get(route('admin.products.index'))">
                <admin-search-form v-model="form.search"></admin-search-form>
            </form>
            <div class="px-2 md:px-6 pt-2 md:pt-4 pb-2">
                <div class="overflow-x-auto">
                    <div class="inline-block min-w-full overflow-hidden">
                        <table class="w-full table-auto md:table-fixed">
                            <thead class="uppercase text-gray-600 text-xs font-semibold bg-gray-200">
                                <tr class="hidden lg:table-row">
                                    <th class="bg-grey-100 border-b-2 border-grey-200 font-semibold px-5 py-3 uppercase text-sm text-left tracking-wider">ID</th>
                                    <th class="bg-grey-100 border-b-2 border-grey-200 font-semibold px-5 py-3 uppercase text-sm text-left tracking-wider">Name</th>
                                    <th class="bg-grey-100 border-b-2 border-grey-200 font-semibold px-5 py-3 uppercase text-sm text-left tracking-wider">Brand</th>
                                    <th class="bg-grey-100 border-b-2 border-grey-200 font-semibold px-5 py-3 uppercase text-sm text-left tracking-wider">&nbsp;</th>
                                </tr>
                            </thead>
                            <tbody class="my-3 flex-1 lg:flex-none">
                                <tr v-if="products.data.length" v-for="product of products.data" class="mb-2 lg:mb-0 border-2 lg:border-b-2 border-grey-200 lg:border-t lg:first:border-t-0 flex p-1 md:p-3 hover:bg-gray-100 lg:table-row flex-col w-full flex-wrap">
                                    <td class="p-1 lg:p-5 lg:border-l-2 lg:border-b border-grey-200 bg-white text-sm md:text-base">
                                        <label class="mb-3 bg-grey-100 border-b-2 border-grey-200 font-semibold px-5 py-3 uppercase text-sm text-left tracking-wider block lg:hidden">ID</label>
                                        {{ product.id }}
                                    </td>
                                    <td class="p-1 lg:p-5 lg:border-b border-grey-200 bg-white text-sm md:text-base">
                                        <label class="mb-3 bg-grey-100 border-b-2 border-grey-200 font-semibold px-5 py-3 uppercase text-sm text-left tracking-wider block lg:hidden">Name</label>
                                        {{ product.name }}
                                    </td>
                                    <td class="p-1 lg:p-5 lg:border-b border-grey-200 bg-white text-sm md:text-base">
                                        <label class="mb-3 bg-grey-100 border-b-2 border-grey-200 font-semibold px-5 py-3 uppercase text-sm text-left tracking-wider block lg:hidden">Brand</label>
                                        {{ product.brand?.name ? product.brand.name : "N/A" }}
                                    </td>
                                    <td class="px-5 py-5 lg:border-r lg:border-b border-grey-200 bg-white text-center lg:text-left text-sm md:text-base">
                                        <admin-link class="bg-grey-100 text-dark"
                                                    :href="route('products.show', product)"
                                                    target="_blank">View
                                        </admin-link>
                                        <admin-link :href="route('admin.products.edit', product)">Edit</admin-link>
                                        <admin-link type="button" class="bg-red" @click="showDeleteModal(product.id)">Delete</admin-link>
                                        <admin-delete-modal v-if="deleteModalIdToShow === product.id" :msg="modalMessage" :type="modalType" @toggle-delete-modal="hideDeleteModal()" @delete-item="deleteItem(product.id)"></admin-delete-modal>
                                    </td>
                                </tr>
                                <tr v-else>
                                    <td class="py-6 bg-red" colspan="4" align="center">
                                        <p class="text-white font-bold">No products found</p>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <admin-pagination class="my-6" :links="products.links" />
                    </div>
                </div>
            </div>
        </div>
        <ToTopLink>To Top</ToTopLink>
    </BreezeAuthenticatedLayout>
</template>

<script>
import AdminLink from "@/Components/Admin/AdminLink";
import AdminDeleteModal from "@/Components/Admin/AdminDeleteModal";
import AdminPagination from "@/Components/Admin/AdminPagination";
import BreezeAuthenticatedLayout from '@/Layouts/Admin/Authenticated.vue';
import {Head, useForm} from '@inertiajs/inertia-vue3';
import { Link } from '@inertiajs/inertia-vue3';
import BreadCrumbs from "@/Components/Admin/BreadCrumbs";
import AdminSearchForm from "@/Components/Admin/Forms/AdminSearchForm";
import ToTopLink from "@/Components/Admin/ToTopLink";
export default {
    name: "Index",
    components:
    {
        AdminPagination,
        AdminDeleteModal,
        AdminSearchForm,
        AdminLink,
        BreadCrumbs,
        Link,
        Head,
        ToTopLink,
        BreezeAuthenticatedLayout
    },
    data()
    {
        return {
            breadCrumbs: [
                { title: 'Products', path: '/admin/products'}
            ],
            deleteModalIdToShow: false,
            modalMessage: 'Are you sure you want to delete this product?',
            modalType: 'Product',
            form: useForm({
                search: this.term
            })
        }
    },
    props: {
        products: Object,
        term: String
    },
    methods: {
        showDeleteModal(id)
        {
            this.deleteModalIdToShow = id;
        },
        hideDeleteModal()
        {
            this.deleteModalIdToShow = false;
        },
        deleteItem(id)
        {
            this.$inertia.delete('/admin/products/'+id);
        },
        capitaliseFirst(str)
        {
            if (!str) return;
            return str.match("^[a-z]") ? str.charAt(0).toUpperCase() + str.substring(1) : str;
        }
    }
}
</script>

<style scoped>

</style>
